var render = function(_h, _vm) {
  var _c = _vm._c
  return _c("img", {
    staticClass: "icon icon-svg",
    attrs: { src: require("@/static/svg/icon_sad.svg"), alt: "Sad face" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }